import { parseImgUrl } from 'src/filter/modules/img';
import * as utils from "src/store/utils";
const keys = {
	detailItemList: {
		imgUrl: '',
		usedPosition: '',
		methodRemark: ''
	},
	sizeItemList: {
		itemNo: '',
		usedPosition: '',
		degreeMethod: '',
		increaseOrDecrease: '',
		remark: '',
		frontBasic: '',
		backBasic: '',
		sizeMap: {}
	},
	descriptionList: {
		imgUrl: '',
		componentCode: '',
		componentTypeVal: '',
		codeList: [],
		materialTypeVal: '',
		usedPosition: '',
		componentDesc: '',
		vendorName: '',
		developer: '',
		joinCostAccountingFlag: '',
		basicUnit: '',
		supplyIndicator: '',
		remark: ''
	}
};

export const mixins = {
	filters: {
		parseImgUrl
	},
	methods: {
		handleAdd(attrName) {
			if (attrName == 'detailItemList' && this.info[attrName].length >= 11) {
				return this.$message({
					type: 'warning',
					message: '最多11行'
				})
			}
			const item = this.$utils.JsonDeepCopy(keys[attrName]);
			if (attrName == 'sizeItemList') {
				item.itemNo = (Number(this.info.sizeItemList.length) + 1) * 10
			}
			this.info[attrName].push(item);
		},
		handleSelectItem(list) {
			this.selectList = list;
		},
		handleDelete(attrName) {
			this.selectList.forEach(item => {
				const index = this.info[attrName].findIndex(inner => inner == item);
				if (index > -1) {
					this.info[attrName].splice(index, 1);
				}
			})
		}
	},
	data() {
		return {
			selectList: []
		}
	}
}

// 表格提取头
export function formatTableHead(array) {
	if (array.length > 0) return array[0]
	return [];
}
// 表格提取内容
export function formatTableCTX(array) {
	return array.filter((item, $index) => $index !== 0).map(item => item);
}
// 拼接表格
export function formatJoinColor(arrayHead, arrayCtx) {
	return [arrayHead, ...arrayCtx];
}

export function formatGradInfo(sizeItemList, gradCodeList, sizeCodeList = []) {
	const gradMapCopy = gradCodeList.reduce((pre, next) => {
		pre[next.sizeName] = 0; return pre;
	}, {})
	return sizeItemList.map(item => {
		const innerGradMap = Object.keys(gradMapCopy).reduce((pre, next) => {
			if (!item.gradMap[next]) {
				pre[next] = null;
				pre[next] = 0;
			} else {
				pre[next] = item.gradMap[next]
			}
			return pre;
		}, {})
		sizeCodeList.forEach(_item => {
			if(!item.sizeMap[_item.sizeName]) {
				item.sizeMap[_item.sizeName] = '0'
			}
		})
		return {
			...item,
			gradMap: innerGradMap

		}
	})
}

export function jumpSizeComputedRow(row) {
	const isNumber = utils.isNumber;
	const codonSelected = this.info.codonSelected;

	const index = this.info.gradCodeList.findIndex(
		inner => codonSelected.indexOf(inner.sizeName) > -1
	);
	console.log('jumpSizeComputedRow')
	if (index === -1) return false;

	const preKey = this.info.gradCodeList.slice(0, index);
	const nextKey = this.info.gradCodeList.slice(index + 1);

	const baseNumber = row.gradMap[this.info.gradCodeList[index].sizeName];

	preKey.forEach((inner, $index) => {
		if (!isNumber(row.frontBasic)) return false;
		if (!isNumber(baseNumber)) return false;

		row.gradMap[inner.sizeName] = toNumber(row.frontBasic);
	});
	nextKey.forEach((inner, $index) => {
		if (!isNumber(row.backBasic)) return false;
		if (!isNumber(baseNumber)) return false;
		row.gradMap[inner.sizeName] = toNumber(row.backBasic);
	});
}
export function jumpSizeOuterComputedRow(row) {
	console.log('jumpSizeOuterComputedRow')
	const keys = {
		codeSize: true,
		pieceSize: true,
	}
	const isNumber = utils.isNumber;
	const codonSelected = this.info.codonSelected; // 基码
	const gradCodeList = this.info.gradCodeList;
	const sizeCodeList = this.info.sizeCodeList.filter(item => keys[item.sizeCode] !== true);
	const index = sizeCodeList.findIndex(
		inner => inner.sizeName.indexOf(codonSelected) > -1
	);

	if (index === -1) return false;

	const preKey = utils.JsonDeepCopy(sizeCodeList.slice(0, index)).reverse(); // 基码之前
	const nextKey = utils.JsonDeepCopy(sizeCodeList.slice(index + 1)); // 基码之后


	const baseNumber = findMapValue(codonSelected, row.sizeMap, sizeCodeList) // 基码数值

	preKey.forEach((item, $index) => {
		const num = preKey.filter((inner, $innerDx) => $innerDx <= $index).reduce((pre, next) => {
			pre = toNumber(pre + toNumber(findMapValue(next.sizeName, row.gradMap, gradCodeList)))
			return pre
		}, 0)
		const sizeKey = findMapKey(item.sizeName, row.sizeMap, sizeCodeList);
		if (_isNumber(row.sizeMap[sizeKey]) === true) return false;
		row.sizeMap[sizeKey] = toNumber(toNumber(baseNumber) - toNumber(num));
	})
	nextKey.forEach((item, $index) => {
		const num = nextKey.filter((inner, $innerDx) => $innerDx <= $index).reduce((pre, next) => {
			pre = toNumber(pre + toNumber(findMapValue(next.sizeName, row.gradMap, gradCodeList)))
			return pre
		}, 0)
		const sizeKey = findMapKey(item.sizeName, row.sizeMap, sizeCodeList);
		if (_isNumber(row.sizeMap[sizeKey]) === true) return false;
		row.sizeMap[sizeKey] = toNumber(toNumber(baseNumber) + toNumber(num));
	})

}

function findMapValue(key, sourceObj, list) {
	const sourceKey = findMapKey(key, sourceObj, list);
	return sourceObj[sourceKey] || 0;
}

function findMapKey(key, sourceObj, list) {
	const keys = {
		codeSize: true,
		pieceSize: true,
	}
	// const target = list.filter(item => keys[item.sizeName] !== true).find(item => key.indexOf(item.sizeName) > -1);
	const target = list.filter(item => {
		return keys[item.sizeName] !== true && item.sizeName === key
	});
	// debugger
	if (target.length) return target[0].sizeName
	console.log(key, sourceObj, list, '没有发现')
	return ''
}

function toNumber(val) {
	return Number(utils.toFixed(val))
}
function _isNumber(val) {
	return isNaN(Number(val));
}